export const NEW_MOBILE_UX_COOKIE = 'pmwmux';
export const NEW_MOBILE_UX_HAS_SEEN_VALUE_LIMIT = 3;
